import "./index.sass";
import { useTranslation } from "@helpers/translate";

const MarketSecondCap = ({ currentValue = 30, maxValue = 100 }) => {
  const { __ } = useTranslation();

  const SEGMENT_BLUE = 25;
  const SEGMENT_TEAL = 15;
  const SEGMENT_YELLOW = 25;
  const SEGMENT_DARK = 35;

  const THUMB_POSITION = SEGMENT_BLUE + SEGMENT_TEAL;

  return (
    <div className="market-second-cap">
      <h3 className="market-second-cap__title">{__("markets.bitcoinDominanceMarketCap")}</h3>

      <div className="market-second-cap__value">
        <span className="market-second-cap__current">{currentValue}</span>
        <span className="market-second-cap__max">/{maxValue}</span>
      </div>

      <div className="market-second-cap__labels">
        <span className="market-second-cap__label">{__("markets.bitcoin")}</span>
        <span className="market-second-cap__label">{__("markets.altcoin")}</span>
      </div>

      <div className="market-second-cap__slider">
        <div
          className="market-second-cap__segment market-second-cap__segment--blue"
          style={{ width: `${SEGMENT_BLUE}%` }}
        />
        <div
          className="market-second-cap__segment market-second-cap__segment--teal"
          style={{ width: `${SEGMENT_TEAL}%` }}
        />
        <div
          className="market-second-cap__segment market-second-cap__segment--yellow"
          style={{ width: `${SEGMENT_YELLOW}%` }}
        />
        <div
          className="market-second-cap__segment market-second-cap__segment--dark"
          style={{ width: `${SEGMENT_DARK}%` }}
        />
        <div
          className="market-second-cap__thumb"
          style={{ left: `${THUMB_POSITION}%` }}
        />
      </div>
    </div>
  );
};

export default MarketSecondCap;
